import { Link } from 'react-router-dom'
import mobile from '../../assets/Ourapp/mobile.png'
import mobileDesktop from '../../assets/Ourapp/mobileDesktop.png'

const AppHeader = () => {
  return (
    <div className='w-full box-border  flex  flex-col  lg:flex-row lg:justify-between items-center lg:pl-10 xl:pl-11  2xl:pl-20'>
      <div className='flex flex-col items-center lg:items-start gap-8 lg:gap-12 2xl:gap-15'>
        <div className='flex flex-col items-center lg:items-start gap-4 self-stretch'>
          <h1 className='text-2xl font-bold leading-8 tracking-wide text-[#093269]   lg:leading-normal lg:text-4xl 2xl:text-[64px]'>
            Our App
          </h1>
          <p className='text-sm font-medium text-[#122D5C]  leading-normal lg:text-lg lg:font-bold lg:leading-6  lg:tracking-wide '>
            The only A.I. trained to diagnose your legal issue.
          </p>
        </div>
        <Link
          to='https://apps.apple.com/gb/app/legal-utopia/id1487650991'
          target='_blank'
          rel='noopener noreferrer'
          className='text-sm font-medium text-white text-center leading-4  tracking-wide bg-[#020251] shadow-[0_1px_4px_0_rgba(0,0,0,0.25)]
            h-6 w-[150px] py-[4px] px-[8px] rounded-sm lg:text-base lg:leading-5  lg:h-11 lg:w-[174px] lg:px-[16px] lg:py-[12px] lg:rounded-lg flex items-center justify-center'
        >
          Get started today
        </Link>
        <div className='lg:hidden'>
          <img src={mobile} className='w-[58] h-[120]' />
        </div>
      </div>
      <div className='hidden lg:block'>
        <img
          src={mobileDesktop}
          className='lg:w-[592.53px] lg:h-[424.37px] xl:w-[741.33px] xl:h-[530.67px] 2xl:w-[889.6px] 2xl:h-[636.8px] 3xl:w-[1112px] 3xl:h-[796px]'
        />
      </div>
    </div>
  )
}

export default AppHeader
